( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
      if ( $( window ).width() > 1024 ) {
        // on desktop, open the first menu on each dropdown panel
        $( '.navigation-four .primary-menu-first__default-open' ).trigger( 'click' );

        // ADA close menu when focus shifts outside of it
        $( '.navigation-four .primary-navigation__panels' ).on( 'focusout', function( e ) {
          const $menuItem = $( this );
          const newFocus = e.relatedTarget;
          if ( newFocus === null ) return;
          if ( !$menuItem.has( newFocus ).length ) {
            const $trigger = $menuItem.find( '.primary-menu-item__link.is-open' );
            if ( $trigger.length ) {
              $trigger.trigger( 'click' );
              newFocus.focus();
            }
          }
        } );
      }
    },
  };

  app.registerComponent( 'navigation-four', COMPONENT );
} )( app );
